// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { SimpleBarChart } from '@/components/composite/Charts/SimpleBarChart';

export const reactionsDistributionConfig = {
    title: 'chart.facebook.reactions_distribution',
    tooltip: 'chart.facebook.tooltip_reactions_distribution',
    id: 'reactions_distribution',
    noTickFormat: true,
    margin: {
        left: -40
    },
    name: {
        reaction: 'chart.facebook.reactions_type',
        value: 'count'
    },
    social: FACEBOOK,
    customTick: { type: 'reaction' },
    valueFormat: classicFormat,
    multipleColors: true,
    multipleColorEntry: 'reaction',
    color: {
        like: 'blue',
        love: 'red',
        wow: 'green',
        haha: 'yellow',
        sad: 'purple',
        angry: 'aquablue'
    },
    size: SIZE_50,
    type: 'chart',
    element: SimpleBarChart
};
